import React from "react";
import { MenuItem, TextField } from "@mui/material";

/** The "no filter" value of a type dropdown. */
export const ALL_KINDS = "";

/**
 * The type dropdown of a combined list (all selection types, all
 * reproduction types): "All types" or one of ``options`` ([{ value, label }]).
 */
export default function KindFilterSelect({ label, options, value, onChange, sx }) {
    return (
        <TextField
            select
            size="small"
            label={label}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            // ALL_KINDS is the empty string, so the label has to be pinned
            // shrunk and the empty value rendered explicitly.
            SelectProps={{ displayEmpty: true }}
            InputLabelProps={{ shrink: true }}
            sx={{ minWidth: 180, ...(sx || {}) }}
        >
            <MenuItem value={ALL_KINDS}>
                <em>All types</em>
            </MenuItem>
            {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
}
